export function goToDirections(latitude, longitude) {
  navigator.geolocation.getCurrentPosition(
    (position) => {
      const startLat = position.coords.latitude;
      const startLong = position.coords.longitude;

      const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${startLat},${startLong}&destination=${latitude},${longitude}`;
      const popup = window.open(googleMapsUrl, '_blank');

      if (!popup) {
        alert('Pop-up blocked! Redirecting to Google Maps in the same tab.');
        window.location.href = googleMapsUrl; // Fallback to same tab if pop-up is blocked
      }
    },
    (err) => {
      alert('Please enable location services to use this feature');
    },
  );
}

export function showLocationOnMap(latitude, longitude) {
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
  const popup = window.open(googleMapsUrl, '_blank');

  if (!popup) {
    alert('Pop-up blocked! Redirecting to Google Maps in the same tab.');
    window.location.href = googleMapsUrl; // Fallback to same tab if pop-up is blocked
  }
}

export function dmsToDecimal([degrees, minutes, seconds], gpsRef) {
  if (gpsRef === 'N' || gpsRef === 'E') {
    return degrees + minutes / 60 + seconds / 3600;
  } else {
    return -(degrees + minutes / 60 + seconds / 3600);
  }
}

export function isValidLatLong({latitude, longitude}) {
  
  const isLatValid =  latitude >= -90 && latitude <= 90;
  const isLonValid =  longitude >= -180 && longitude <= 180;

  return isLatValid && isLonValid;
}

/**
 * Read the device's current position.
 *
 * @param {PositionOptions} [options] Forwarded verbatim to
 *   `navigator.geolocation.getCurrentPosition`. Omit it to keep the browser
 *   default (low-power, cached fix allowed, no timeout).
 * @returns {Promise<{ latitude: number, longitude: number, accuracy: number }>}
 *   `accuracy` is the radius of the 95% confidence circle **in metres**, as the
 *   Geolocation API reports it. Keep it in metres everywhere; convert to feet
 *   in the display formatter only, so no threshold or comparison has to guess
 *   which unit it is holding.
 */
export function getCurrentPosition(options) {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        const accuracy = position.coords.accuracy;

        resolve({ latitude, longitude, accuracy });
      },
      (err) => {
        alert('Please enable location services to use this feature');
        reject(err);
      },
      options,
    );
  });
}
